var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"liveContainer"}},[_c('iframe',{attrs:{"src":`${_vm.link}`,"frameborder":"0","allowfullscreen":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }